'use strict';

const {parse, format} = require('url');
const crypto = require('crypto');
const querystring = require('querystring');

// const Base = require('./base');

const form = 'application/x-www-form-urlencoded';
const json= 'application/json';

const hasOwnProperty = function (obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};


/**
 * API Gateway Base
 */

function loweredKeys(headers = {}) {
  var lowered = {};

  var keys = Object.keys(headers);
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    lowered[key] = headers[key];
  }

  return lowered;
}
export  class Base {
  constructor() {
  }

  get(url, opts = {}) {
    var parsed = parse(url, true);
    var maybeQuery = opts.query || opts.data;
    if (maybeQuery) {
      // append data into querystring
      Object.assign(parsed.query, maybeQuery);
      parsed.path = parsed.pathname + '?' + querystring.stringify(parsed.query);
      opts.data = null;
      opts.query = null;
    }

    // lowerify the header key
    opts.headers = loweredKeys(opts.headers);
    opts.signHeaders = loweredKeys(opts.signHeaders);

    return this.request('GET', parsed, opts);
  }

  post(url, opts = {}) {
    var parsed = parse(url, true);
    var query = opts.query;
    if (query) {
      Object.assign(parsed.query, query);
	    
      parsed.path = parsed.pathname + '?' + querystring.stringify(parsed.query);
      opts.query = null;
    }

    // lowerify the header key
    opts.headers = loweredKeys(opts.headers);
    opts.signHeaders = loweredKeys(opts.signHeaders);

    
	var headers = opts.defaulthead;
	var type = headers['content-type'] || headers['Content-Type'];
	if (!type) {
	  headers['content-type'] = 'application/x-www-form-urlencoded';
	  type = headers['content-type'];
	}

    var originData = opts.data;
	
    if (type.startsWith('application/x-www-form-urlencoded')) {
      opts.data = querystring.stringify(opts.data);
	  // console.log("form",opts.data);
    } else if (type.startsWith('application/json')) {
      opts.data = JSON.stringify(opts.data);
	  // console.log("json",opts.data);
    } else if (!Buffer.isBuffer(opts.data) && typeof opts.data !== 'string') {
      // 非buffer和字符串时，以JSON.stringify()序列化
      opts.data = JSON.stringify(opts.data);
    }
	opts.headers['content-type']=type;
    return this.request('POST', parsed, opts, originData);
  }

  put(url, opts = {}) {
    var parsed = parse(url, true);
    var query = opts.query;
    if (query) {
      // append data into querystring
      Object.assign(parsed.query, query);
      parsed.path = parsed.pathname + '?' + querystring.stringify(parsed.query);
      opts.query = null;
    }

    // lowerify the header key
    opts.headers = loweredKeys(opts.headers);
    opts.signHeaders = loweredKeys(opts.signHeaders);

    var headers = opts.headers;
    var type = headers['content-type'] || headers['Content-Type'];
    if (!type) {
      headers['content-type'] = 'application/json';
      type = headers['content-type'];
    }

    var originData = opts.data;
    if (type.startsWith('application/x-www-form-urlencoded')) {
      opts.data = querystring.stringify(opts.data);
    } else if (type.startsWith('application/json')) {
      opts.data = JSON.stringify(opts.data);
    } else if (!Buffer.isBuffer(opts.data) && typeof opts.data !== 'string') {
      // 非buffer和字符串时，以JSON.stringify()序列化
      opts.data = JSON.stringify(opts.data);
    }

    return this.request('PUT', parsed, opts, originData);
  }

  delete(url, opts) {
    var parsed = parse(url, true);
    var maybeQuery = opts.query || opts.data;
    if (maybeQuery) {
      // append data into querystring
      Object.assign(parsed.query, maybeQuery);
      parsed.path = parsed.pathname + '?' + querystring.stringify(parsed.query);
      opts.data = null;
      opts.query = null;
    }

    // lowerify the header key
    opts.headers = loweredKeys(opts.headers);
    opts.signHeaders = loweredKeys(opts.signHeaders);

    return this.request('DELETE', parsed, opts);
  }
}

/**
 * API Gateway Client
 */
export  class Client extends Base {
  constructor(secret, stage = 'RELEASE') {
    super();
    // this.appKey = key;
    this.appSecret = Buffer.from(secret, 'utf8');
    this.stage = stage;
  }

  buildStringToSign(method, headers, signedHeadersStr, url, data) {
    // accept, contentMD5, contentType,
	// console.log("签名信息",method,url,data);
    const lf = '';
    var list = [method, lf];

    var contentMD5 = headers['content-md5'];
    if (contentMD5) {
      list.push(contentMD5);
    }
    list.push(lf);

    var contentType = headers['content-type'] || '';
  

    var date = headers['date'];
    if (date) {
      list.push(date);
    }
    list.push(lf);

    if (signedHeadersStr) {
      list.push(signedHeadersStr);
      list.push(lf);
    }

    if (contentType.startsWith(form)) { //formate数据
      list.push(this.buildUrl(url, data));
    } else{   //json数据
      list.push(this.buildUrl(url,data,method));
    }
    return list.join('');
  }

  sign(stringToSign) {
    return crypto.createHmac('sha256', this.appSecret)
      .update(stringToSign, 'utf8').digest('base64');
  }

  md5(content) {
	  // console.log("参数",content);
	  if(content){
		return crypto.createHash('md5')
		  .update(content, 'utf8')
		  .digest('base64');
	  }else{
		  return;
	  }
  }

  getSignHeaderKeys(headers, signHeaders) {
    var keys = Object.keys(headers).sort();
    var signKeys = [];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // x-ca- 开头的header或者指定的header
      if (key.startsWith('x-ca-') || hasOwnProperty(signHeaders, key)) {
        signKeys.push(key);
      }
    }

    // 按字典序排序
    return signKeys.sort();
  }

  buildUrl(parsedUrl,data,method) {
	  var toStringify;
	  if(method=='POST'){
		  console.log("post-json");
		  toStringify = Object.assign({},{});
	  }
	  else{
		  console.log("post-form/get-json");
		  toStringify = Object.assign(parsedUrl.query, data);
	  }
	
    var result = parsedUrl.pathname;
    if (Object.keys(toStringify).length) {
      var keys = Object.keys(toStringify).sort();
      var list = new Array();
	  var j=0;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (toStringify[key] !== undefined && toStringify[key] !== null && ('' + toStringify[key])) {
		  // list[j] = `${key}=${encodeURIComponent(toStringify[key])}`;  //签名参数url转义
		  list[j] = `${key}=${toStringify[key]}`;
		  j++;
        } 
      }
      result += '?' + list.join('&');
    }
    return result;
  }

  buildHeaders(headers = {}, signHeaders) {
    return Object.assign({
      // 'x-ca-timestamp': '123',
      // 'x-ca-key': this.appKey,
      // 'x-ca-nonce': uuid.v4(),
      // 'x-ca-stage': this.stage,
      // 'accept': 'application/json'
    }, headers, signHeaders);
  }

  getSignedHeadersString(signHeaders, headers) {
    var list = [];
    for (var i = 0; i < signHeaders.length; i++) {
      var key = signHeaders[i];
      list.push(key + ':' + headers[key]);
    }

    return list.join('');
  }

//method+bodyStr(jsonMd5)+header+params(form\query) => sign
  request(method, url, opts, originData) {
    var signHeaders = opts.signHeaders;
    // 小写化，合并之后的headers
    var headers = this.buildHeaders(opts.headers, signHeaders);
    var requestContentType = headers['content-type'] || '';
	
    if (method === 'POST' && !requestContentType.startsWith(form)) {
      headers['content-md5'] = this.md5(opts.data);
    }

    var signHeaderKeys = this.getSignHeaderKeys(headers, signHeaders);
    //headers['x-ca-signature-headers'] = signHeaderKeys.join(',');
    var signedHeadersStr = this.getSignedHeadersString(signHeaderKeys, headers);

    var parsedUrl = parse(url, true);
    var stringToSign = this.buildStringToSign(method, headers, signedHeadersStr, parsedUrl, originData);
	// console.log("签名前:",stringToSign);
	headers['sign'] = this.sign(stringToSign);
	
	return headers;
	
  }
}

// module.exports = Client;